import * as React from "react";
import * as ReactDOM from "react-dom";
import styles from "./modal-view.module.css";

export interface IModalProps {
  width?: string;
  onClose: () => void;
  children: (() => React.ReactNode) | React.ReactNode;
  isOverlayClose?: boolean;
  isNoFlex?: boolean; //TODO tepm prop for backward compatibility
  config?: ModalConfig;
  position: "flex-start" | "center";
  style?: any;
}

export const ModalView: React.FC<IModalProps> = ({
  width = "auto",
  position = "center",
  onClose,
  children,
  isOverlayClose = true,
  config = {},
  style,
}) => {
  const overlayRef = React.useRef<HTMLDivElement>(null);
  const modalWrapRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    config.scrollTo = () => {
      if (overlayRef.current && modalWrapRef.current) {
        overlayRef.current.scrollTo(0, modalWrapRef.current.offsetHeight);
      }
    };
    config.closeModal = () => {
      if (overlayRef.current) {
        overlayRef.current.style.display = "none";
      }
    };
    config.openModal = () => {
      if (overlayRef.current) {
        overlayRef.current.style.display = "flex";
      }
    };
  }, [config]);

  return ReactDOM.createPortal(
    <div
      className={styles.modalOverlay}
      ref={overlayRef}
      style={{
        ...style,
        position,
      }}
      onClick={() => isOverlayClose && onClose()}
      id="modal-overlay"
    >
      <div className={styles.modalWrap} ref={modalWrapRef}>
        <div className={styles.modal} {...getContentProps(config, width)}>
          {children instanceof Function ? children() : children}
        </div>
      </div>
    </div>,
    document.body
  );
};
ModalView.displayName = "ModalView";

interface ModalConfig extends Record<string, any> {
  contentProps?: React.ComponentProps<typeof ModalView>;
}

function getContentProps(config: ModalConfig, width: string) {
  const { contentProps = { style: {} } } = config;

  const defaultProps = {
    style: { width },
    onClick: (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
    },
  };

  const style = { ...defaultProps.style, ...contentProps.style };

  return {
    ...defaultProps,
    ...contentProps,
    style,
  };
}
